import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Alert, Typography, Layout } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import AppHeader from '../components/AppHeader/AppHeader';
import { authService } from '../services/api';
import { useNavigate, useLocation } from 'react-router-dom';
import '../App.css';

const { Title } = Typography;
const { Content } = Layout;

const LoginPage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();

    // Проверка авторизации при загрузке страницы
    useEffect(() => {
        // Сначала сохраняем OAuth параметры из URL, если они есть
        const urlParams = new URLSearchParams(location.search);
        const hasOAuthParams = urlParams.get('client_id') && urlParams.get('redirect_uri');

        if (hasOAuthParams && !localStorage.getItem('oauth_params')) {
            const oauthParams = {
                client_id: urlParams.get('client_id'),
                redirect_uri: urlParams.get('redirect_uri'),
                response_type: urlParams.get('response_type'),
                scope: urlParams.get('scope'),
                state: urlParams.get('state'),
                code_challenge: urlParams.get('code_challenge'),
                code_challenge_method: urlParams.get('code_challenge_method'),
                auth_request_id: urlParams.get('auth_request_id')
            };
            localStorage.setItem('oauth_params', JSON.stringify(oauthParams));
        }

        if (authService.isAuthenticated()) {
            const oauthParams = localStorage.getItem('oauth_params');

            if (oauthParams) {
                if (authService.hasTemporaryPassword()) {
                    navigate('/change-temporary-password');
                } else {
                    navigate('/oauth/authorize');
                }
            } else {
                if (authService.hasTemporaryPassword()) {
                    navigate('/change-temporary-password');
                } else {
                    navigate('/');
                }
            }
        }
    }, [navigate, location.search]);

    const onFinish = async (values) => {
        setLoading(true);
        setError('');

        const { username, password } = values;
        const result = await authService.login(username, password);

        setLoading(false);

        if (result.success) {
            // Проверяем, есть ли сохраненные параметры OAuth
            const oauthParams = localStorage.getItem('oauth_params');

            if (oauthParams) {
                // Если у пользователя временный пароль, перенаправляем его на страницу изменения пароля
                if (authService.hasTemporaryPassword()) {
                    navigate('/change-temporary-password');
                } else {
                    // Перенаправляем на страницу OAuth авторизации
                    navigate('/oauth/authorize', {
                        state: {
                            oauthParams: JSON.parse(oauthParams)
                        }
                    });
                }
            } else {
                // Стандартная логика редиректа
                if (authService.hasTemporaryPassword()) {
                    navigate('/change-temporary-password');
                } else {
                    navigate('/');
                }
            }
        } else if (result.pending2FA) {
            navigate('/two-factor-auth');
        } else {
            setError(result.message);
            form.resetFields(['password']); // Очищаем только поле пароля при ошибке
        }
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <AppHeader />
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px' }}>
                <div style={{ width: '100%', maxWidth: '400px' }}>
                    <Title level={3} style={{ marginBottom: '24px' }}>Войдите, чтобы продолжить</Title>

                    {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 24 }} />}

                    <Form
                        name="login_form"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        size="large"
                        layout="vertical"
                        form={form}
                    >
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: 'Пожалуйста, введите имя пользователя!' }]}
                        >
                            <Input prefix={<UserOutlined />} placeholder="Имя пользователя" />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Пожалуйста, введите пароль!' }]}
                        >
                            <Input.Password prefix={<LockOutlined />} placeholder="Пароль" />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="login-button" loading={loading} block>
                                Войти
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Content>
        </Layout>
    );
};

export default LoginPage;